var cardCarouselInter = (function () {
  return {
    init: init,
  };

  function init() {
    resSlider();
    window.addEventListener("resize", resSlider);
  }
  function resSlider() {
    if (window.innerWidth < 980) {
      var slider = new bstackSlider({
        selector: ".card-block-inter--style-4.card-block-inter--carousel",
        cssClass: [],
        showDots: true,
        cardsInSlide: {
          640: 1,
          320: 1,
        },
        gap: {
          640: 0,
          320: 0,
        },
      });
    }
  }
})();

window.addEventListener("load", function () {
  cardCarouselInter.init();
});
